<app-network-status></app-network-status>
<app-loader></app-loader>
<router-outlet></router-outlet>
<app-usage-overview-minimized />